import { Route } from "@angular/router";
import { ExpirarPage } from "./expirar.page";

export const ExpirarRouter: Route[] = [
  { path: 'expirar', component: ExpirarPage }
];
